import React, { Component } from 'react'
import Button from '../Button'
import './mobileheader.scss'

class MobileHeader extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	toggleMenu(e) {
		let btnIcon = e.target.querySelector('span')
		let menu = document.querySelector('.mobile-menu')
		if (menu.classList.contains('open')) {
			menu.classList.remove('open')
			menu.querySelector('.viewport').classList.remove('displaced')
			btnIcon.classList.remove('icon-icon-menu-close')
			btnIcon.classList.add('icon-icon-menu')
		} else {
			menu.classList.add('open')
			btnIcon.classList.remove('icon-icon-menu')
			btnIcon.classList.add('icon-icon-menu-close')
		}
	}

	toggleSubmenu(e) {
		let viewport = document.querySelector('.viewport')
		if (viewport.classList.contains('displaced')) {
			viewport.classList.remove('displaced')
			let sublevels = viewport.querySelectorAll('.sublevel')
			setTimeout(function () {
				sublevels.forEach(function (element) {
					element.classList.remove('active')
				})
			}, 300)
		} else {
			let sublevelActive = document.getElementById(e.target.getAttribute('data-href'))
			sublevelActive.classList.add('active')
			viewport.classList.add('displaced')
		}
	}

	changeLanguage(e) {
		let viewport = document.querySelector('.viewport')
		let langBtn = viewport.querySelector('.lang-selector button .language-selected')
		let langList = document.getElementById('language')
		let langOps = langList.querySelectorAll('.language-option button')
		langBtn.innerHTML = e.target.innerHTML.slice(0, 2)
		this.toggleSubmenu(e)
		langOps.forEach(function (element) {
			element.classList.remove('selected')
		})
		e.target.classList.add('selected')
	}

	render() {
		let classes = ['vbui--mobileheader', this.props.classes].join(' ')
		return (
			<div className={classes}>
				<div className="mobile-header">
					<div className="fixed-header">
						<div className="left-item">
							<a href={this.props.data.homeLink} className="logo-button">
								<img src="https://via.placeholder.com/117x34?text=Vibia" alt="" />
							</a>
						</div>
						<div className="right-item">
							<a href={this.props.data.searchLink} id="mob-search-trigger" className="mobile-nav-btn search-trigger">
								<span className="icon-icon-search"></span>
							</a>
							<button id="mob-menu-trigger" className="mobile-nav-btn menu-trigger" onClick={(e) => this.toggleMenu(e)}>
								<span className="icon-icon-menu"></span>
							</button>
						</div>
					</div>
					{this.props.children && <div className="children-container">{this.props.children}</div>}
					<div className="mobile-menu">
						<div className="viewport">
							<div className="data-level" data-level="0">
								<ul className="menu-list">
									{this.props.data.zeroLevel.mainMenu.map((item, i) => {
										return (
											<li className="list-item" key={i}>
												<a key={i} href={item.link}>
													{item.name}
												</a>
											</li>
										)
									})}
									<li className="list-item">
										<button data-href="account" className="account-btn" onClick={(e) => this.toggleSubmenu(e)}>
											<span className="icon-icon-user left-icon"></span>
											{this.props.data.zeroLevel.myAccount} <span className="icon-right follow-icon"></span>
										</button>
									</li>
								</ul>
								<ul className="secondary-list">
									{this.props.data.zeroLevel.secondMenu.map((item, i) => {
										return (
											<li className="list-item" key={i}>
												<a key={i} href={item.link}>
													{item.name}
												</a>
											</li>
										)
									})}
									<li className="list-item lang-selector">
										<button data-href="language" className="language-btn" onClick={(e) => this.toggleSubmenu(e)}>
											<span className="language-selected">{this.props.data.zeroLevel.langDefault}</span>
											<span className="icon-right follow-icon"></span>
										</button>
									</li>
								</ul>
							</div>
							<div className="data-level" data-level="1">
								<div className="sublevel" data-group="#account" id="account">
									<ul className="menu-list">
										<li className="list-item">
											<button data-href="#return" className="return-btn" onClick={(e) => this.toggleSubmenu(e)}>
												<span className="icon-left"></span>
												{this.props.data.firstLevel.account.return}
											</button>
										</li>
										{this.props.data.firstLevel.account.options.map((item, i) => {
											return (
												<li className="list-item" key={i}>
													<a key={i} href={item.link}>
														{item.name}
													</a>
												</li>
											)
										})}
									</ul>
								</div>
								<div className="sublevel" data-group="#language" id="language">
									<ul className="menu-list">
										<li className="list-item">
											<button data-href="" className="return-btn" onClick={(e) => this.toggleSubmenu(e)}>
												<span className="icon-left"></span>
												{this.props.data.firstLevel.lang.return}
											</button>
										</li>
										{this.props.data.firstLevel.lang.options.map((item, i) => {
											return (
												<li className="list-item language-option" key={i}>
													<button data-href="" className={item.selected} onClick={(e) => this.changeLanguage(e)}>
														{item.name}
													</button>
												</li>
											)
										})}
									</ul>
								</div>
							</div>
						</div>
						<div className="btn-container">
							<Button classes="ghost medium" showIcon={true} icon="icon-icon-support">
								{this.props.data.button}
							</Button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default MobileHeader
